<template>
  <router-link
    :to="localePath('Zone', { slug: zone.slug })"
    class="group bg-card rounded-xl border border-border shadow-sm hover:border-primary/30 transition-colors block p-4"
  >
    <div class="flex items-center mb-1">
      <h3
        class="text-lg font-semibold text-primary group-hover:text-primary/80 transition-colors truncate"
      >
        {{ zone.name }}
      </h3>
      <ChevronRight
        class="w-4 h-4 text-primary shrink-0 ml-auto group-hover:translate-x-0.5 transition-transform"
      />
    </div>
    <div class="flex flex-wrap gap-3 text-sm text-muted-foreground">
      <span>{{ $t('zones.trailCount', { count: trailCount }) }}</span>
      <span>{{ $t('zones.poiCount', { count: poiCount }) }}</span>
      <span v-if="distance != null">{{
        $t('zones.distanceAway', { distance: formattedDistance })
      }}</span>
    </div>
  </router-link>
</template>

<script setup>
import { computed } from 'vue'
import { ChevronRight } from 'lucide-vue-next'
import { useLocalePath } from '../composables/useLocalePath'
import { formatDistance } from '../utils/formatDistance'

const props = defineProps({
  zone: { type: Object, required: true },
  distance: { type: Number, default: null },
})

const { localePath } = useLocalePath()

const trailCount = computed(() => props.zone.trail_count ?? props.zone.trails?.length ?? 0)

const poiCount = computed(() => props.zone.poi_count ?? props.zone.pois?.length ?? 0)

const formattedDistance = computed(() => formatDistance(props.distance))
</script>
